// @generated by protoc-gen-es v2.9.0 with parameter "target=dts+js,js_import_style=legacy_commonjs"
// @generated from file description_support/v1/enum_description.proto (package description_support.v1, syntax proto3)
/* eslint-disable */

"use strict";
Object.defineProperty(exports, "__esModule", { value: true });

const { extDesc, fileDesc } = require("@bufbuild/protobuf/codegenv2");
const { file_google_protobuf_descriptor } = require("../../google/protobuf/descriptor_pb");

/**
 * Describes the file description_support/v1/enum_description.proto.
 */
const file_description_support_v1_enum_description = /*@__PURE__*/
  fileDesc("Ci1kZXNjcmlwdGlvbl9zdXBwb3J0L3YxL2VudW1fZGVzY3JpcHRpb24ucHJvdG8SFmRlc2NyaXB0aW9uX3N1cHBvcnQudjE6bAohZW51bV92YWx1ZV9kZXNjcmlwdGlvbl9mb3Jfbm9fc3dlEiEuZ29vZ2xlLnByb3RvYnVmLkVudW1WYWx1ZU9wdGlvbnMYrZADIAEoCVIcZW51bVZhbHVlRGVzY3JpcHRpb25Gb3JOb1N3ZTpeChplbnVtX3ZhbHVlX2hpZGVfZm9yX25vX3N3ZRIhLmdvb2dsZS5wcm90b2J1Zi5FbnVtVmFsdWVPcHRpb25zGK6QAyABKAhSFWVudW1WYWx1ZUhpZGVGb3JOb1N3ZTpeChplbnVtX3ZhbHVlX25hbWVfZm9yX25vX3N3ZRIhLmdvb2dsZS5wcm90b2J1Zi5FbnVtVmFsdWVPcHRpb25zGK+QAyABKAlSFWVudW1WYWx1ZU5hbWVGb3JOb1N3ZWIGcHJvdG8z", [file_google_protobuf_descriptor]);

/**
 * NOTE: パートナーや10X内の非SWEでも理解できるようにフィールドに説明をつけるためのアノテーションです。
 *
 * @generated from extension: string enum_value_description_for_no_swe = 51245;
 */
const enum_value_description_for_no_swe = /*@__PURE__*/
  extDesc(file_description_support_v1_enum_description, 0);

/**
 * NOTE: Enumの値を非SWEには指定出来ないようにするためのアノテーションです。
 *
 * 特定パートナーにのみ提供する機能に使います
 *
 * @generated from extension: bool enum_value_hide_for_no_swe = 51246;
 */
const enum_value_hide_for_no_swe = /*@__PURE__*/
  extDesc(file_description_support_v1_enum_description, 1);

/**
 * NOTE: パートナーや10X内の非SWEでも理解できるようにフィールドにラベル(名前)をつけるためのアノテーションです。
 *
 * @generated from extension: string enum_value_name_for_no_swe = 51247;
 */
const enum_value_name_for_no_swe = /*@__PURE__*/
  extDesc(file_description_support_v1_enum_description, 2);


exports.file_description_support_v1_enum_description = file_description_support_v1_enum_description;
exports.enum_value_description_for_no_swe = enum_value_description_for_no_swe;
exports.enum_value_hide_for_no_swe = enum_value_hide_for_no_swe;
exports.enum_value_name_for_no_swe = enum_value_name_for_no_swe;
